// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/vue-notifyjs/themes/default.css
// module id = p4sG
// module chunks = 0